<template>
    <a-modal 
        v-model="visible" 
        :title="$t('modal.recheck')" 
        :closable="false" 
        :ok-text="$t('modal-btn.alter-confirm-btn-caption')" 
        :cancel-text="$t('modal-btn.alter-cancel-btn-caption')" 
        @ok="handleOk" 
        @cancel="handleCancel"
    >
        <h6>{{$t('recheck-modal.title-application')}}</h6>
        <a-form
            id="components-form-demo-normal-login"
            class="login-form"
            :hideRequiredMark="true"
        >
            <a-form-item 
                class="mb-5" 
                :label="$t('form-label.recheck-reason')" 
                :colon="false"
                :validate-status="validations.statusNewPassword"
                :help="validations.helpNewPassword"
            >
                    <!-- type="password" -->
                <a-input
                    class="form-input"
                    :placeholder="$t('form-placeholder.recheck-reason')"
                    v-model="reason"
                >
                </a-input>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import { companyEnlistmentClient } from "../../../../api/config.js";
import { toastMixin } from "../../../../mixins/ToastMixin.js";
export default {
    name: "CompanyRecheckModal",
    mixins: [ toastMixin ],
    data(){
        return{
            reason: "",
            visible: false,
            applicantId: "",
            validations:{}
        }
    },
    methods:{
        showModal(id) {
            this.visible = true;
            this.applicantId = id;
            // console.log(this.userId);
        },
        handleCancel(){
            this.visible = false;
        },
        handleOk(){
            let data = {
                "id": this.applicantId,
                "reason": this.reason
            }
            companyEnlistmentClient.recheck(data).then(res => {
                if (!res.networkError){
                    if (res.status == 202){
                        this.successToast(this.$t('toast-success-messages.recheck-application'));
                        this.visible = false;
                    }else{
                        this.errorToast(this.$t('toast-error-message.error') + res.status);
                    }
                }else{
                    this.errorToast(this.$t('toast-error-message.network-error'));
                }
            })
        }
    }
}
</script>

<style>

</style>